import React, {Fragment, SyntheticEvent, useEffect, useRef, useState} from "react";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import {v4} from "uuid";
import {Chip, FormLabel} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import HelpOutlineSharpIcon from "@mui/icons-material/HelpOutlineSharp";
import CasinoOutlinedIcon from "@mui/icons-material/CasinoOutlined";
import AddIcon from "@mui/icons-material/Add";
import charcreate from "../../_helper/charcreate";
import {rollerOpen, rollerSetRoll} from "../../_helper/rollBehave";
import {useSignals} from "@preact/signals-react/runtime";
import {s_char, s_char_skills} from "../../_signals/s_char";
import {ICharSkill} from "../../_interfaces/ICharSkill";
import {IRollerRoll} from "../../_interfaces/IRoller";
import {SkillsCreate, SkillsDelete, SkillsUpdate} from "../../_api/BESkills";
import updChar from "../../_sig_api/updChar";
import {styled} from "@mui/material/styles";
import {InfoTalentSkillSubscriber} from "../../_helper/InfoTalentSkillBehave";
import {TalentSkillSubscriber} from "../../_helper/DataBehaves";
import SkillsEdit from "./SkillsEdit";
import EditIcon from "@mui/icons-material/Edit";
import getSkillDefines from "./getSkillDefines";
import skill_improvise from "../../_data/skill_improvise";
import SkillsAdd from "./SkillsAdd";
import skill_creation from "../../_data/skill_creation";
import TextField from "@mui/material/TextField";
import {s_char_attr_ges_step, s_char_attr_step} from "../../_signals/s_char_attr";
import {s_app_mobile} from "../../_signals/s_app";
import CharCreate from "../../_helper/charcreate";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2, padding: 4, height: '100%', textAlign: 'center', color: '#000',
}));

interface IProps {
    roll: boolean
}

function Skills({roll}: IProps) {
    useSignals()

    const [ccFree, setCCFree] = useState({frei: 0, Wissen: 0, Kunsthandwerk: 0, Fremdsprachen: 0, "Lesen/Schreiben": 0})

    const [edit, setEdit] = useState('')
    const [add, setAdd] = useState(false)

    const fix = ['Lesen/Schreiben', 'Kunsthandwerk', 'Fremdsprachen']

    const mod_rank = [...Array(4).keys()];

    const tableContainerRef = useRef<HTMLDivElement>(null);
    const prevScrollTop = useRef<number>(0);

    const [filter, setFilter] = useState('');


    useEffect(() => {
        if (!s_char.value.cc_skills) calcUsedFree()
        if (tableContainerRef.current) {
            tableContainerRef.current.scrollTop = prevScrollTop.current;
        }
    }, [])

    const calcUsedFree = () => {
        const initialFreePoints = CharCreate.fertigkeiten;

        let usedPoints = {
            "frei": 0,
            "Wissen": 0,
            "Kunsthandwerk": 0,
            "Fremdsprachen": 0,
            "Lesen/Schreiben": 0
        };

        s_char_skills.value.forEach((skill) => {
            skill = getSkillDefines(skill)
            const skillName = skill.use_as || skill.name;
            const step = skill.step;

            if (initialFreePoints[skillName] !== undefined && skillName !== "frei") {
                const specificAvailable = initialFreePoints[skillName] - usedPoints[skillName];
                const pointsToTake = Math.min(step, specificAvailable);

                usedPoints[skillName] += pointsToTake;

                // Der Rest wird von den allgemeinen freien Punkten genommen
                const remainingForGeneral = step - pointsToTake;
                usedPoints.frei += remainingForGeneral;
            } else {
                // Wenn die Fertigkeit nur über allgemeine Punkte abgedeckt wird
                usedPoints.frei += step;
            }
        });
        console.log('usedPoints', usedPoints);

        setCCFree(usedPoints);
    }

    const handleInfoPopOpen = (skillname: string, e: SyntheticEvent) => {
        const skill = TalentSkillSubscriber.value.find(s => s.hasOwnProperty('lps_skill') && s.name === skillname)
        if (skill) {
            InfoTalentSkillSubscriber.next({popOpen: true, popEl: e.currentTarget, pop: skill})
        }
    }

    const skillRow = (skill: ICharSkill) => {

        skill = getSkillDefines(skill)

        return <TableRow key={skill.id} style={{
            display: filter ? skill.name.toLowerCase().includes(filter.toLowerCase()) ? 'table-row' : 'none' : 'table-row'
        }}>
            <TableCell width={'100%'}>
                <Stack direction={'row'} justifyContent="space-between" alignItems="baseline">
                    <Fragment>
                        <div>
                            <div style={{fontWeight: 'bolder'}}>{skill.name}</div>
                            <Stack direction={'row'}>
                                {!roll && skill.define.length > 0 ? <div>{skill.define.sort().join(', ')}</div> : null}
                                {!roll && skill.hasOwnProperty('define_multi') && skill.define_multi!.length > 0 && skill.define!.length !== skill.step ?
                                    <Chip size="small" color="error" label="freie Zuweisungen vorhanden"/> : null
                                }
                                {!roll && skill.hasOwnProperty('define_single') && skill.define_single!.length > 0 && skill.define!.length == 0 ?
                                    <Chip size="small" color="error" label="freie Zuweisung vorhanden"/> : null
                                }
                                {!roll && skill.hasOwnProperty('use_as') && skill.use_as == 'Kunstfertigkeit' ?
                                    <Chip size="small" variant={'outlined'} label="Kunstfertigkeit"/> : null
                                }
                                {skill.step == 0 && skill.type == 0 ?
                                    <span style={{fontSize: "smaller"}}>improvisierbar</span> : null
                                }
                            </Stack>
                        </div>
                        <HelpOutlineSharpIcon fontSize={'small'}
                                              onClick={(e) => handleInfoPopOpen(skill.name, e)}/>
                    </Fragment>

                </Stack>
            </TableCell>
            {!roll && <TableCell>
                {s_char.value.cc_skills ? <Stack spacing={2} direction="row">
                        <Stack spacing={2} direction="row">
                            <span>Stufe&nbsp;{skill.step}</span>
                            <Button className={'btn'} size="small" onClick={() => setEdit(skill.id)}>
                                <EditIcon/>
                            </Button>
                        </Stack>
                    </Stack> :
                    <Stack spacing={2} direction="row">
                        <FormLabel>Frei</FormLabel>
                        <Select key={v4()}
                                value={skill.step || '0'}
                                onChange={(e) => changeSkillSteps(skill.id, e)}
                        >
                            {mod_rank.map(r => {
                                return <MenuItem key={v4()} value={r}>{r}</MenuItem>
                            })
                            }
                        </Select>
                    </Stack>}
            </TableCell>}
            <TableCell>
                {s_char.value.cc_skills && (
                    (skill.step >= 0 && skill.type == 0) ||
                    (skill.step !== 0 && skill.type > 0)
                ) ? <Button className={'btn'} size="small" onClick={() => setRoll(skill)}>
                    <CasinoOutlinedIcon/>
                </Button> : null
                }
            </TableCell>
        </TableRow>
    }

    const setRoll = (skill: ICharSkill) => {
        const roll: IRollerRoll = {
            attribute: skill.attribute,
            canusekarma: false,
            karma: false,
            step_mod: 0, // step_mod
            step: skill.step,
            strain: skill.strain,
            title: skill.name,
            target: [],
            targetVS: '',
            vs: '',
            vsnum:0,
            as: '',
            as_fix: false
        };
        rollerSetRoll(roll, true, false);
        rollerOpen();
    }

    const changeSkillSteps = (skillid: string, event: any) => {
        const {value} = event.target;

        let skills = s_char_skills.value

        skills = skills.map(t => {
            if (t.id === skillid) {
                t.step = value;
                SkillsUpdate(t)
            }
            return t;
        });

        if (tableContainerRef.current) {
            prevScrollTop.current = tableContainerRef.current.scrollTop;
        }

        s_char_skills.value = skills
        calcUsedFree()
    }

    const cc_done_skills = () => {
        updChar([{k: 'cc_skills', v: true}])
        let char = s_char.value
        char.cc_skills = true;
        s_char.value = char
    }

    const dist = () => {
        let ret: string[] = []
        for (let fertigkeitenKey in CharCreate.fertigkeiten) {
            ret.push(fertigkeitenKey + ' ' + ccFree[fertigkeitenKey] + ' von ' + CharCreate.fertigkeiten[fertigkeitenKey]);
        }
        return ret;
    }

    const done = () => {
        let ok = true;
        for (let fertigkeitenKey in CharCreate.fertigkeiten) {
            if (CharCreate.fertigkeiten[fertigkeitenKey] !== ccFree[fertigkeitenKey]) ok = false;
        }
        return ok;
    }

    return <Fragment>
        <Paper style={{overflowX: 'auto', marginTop: "14px"}}>
            <h3 style={{margin: "5px", display: 'flex', justifyContent: 'space-between'}}>
                <span>Fertigkeiten</span>
                {!s_char.value.cc_skills ? null :
                    <>
                        <TextField size={'small'} style={{marginLeft: 'auto', marginRight: 10}}
                                   defaultValue={''}
                                   label={'suche'}
                                   value={filter}
                                   onChange={(e) => setFilter(e.target.value)}
                        >
                        </TextField>
                        <AddIcon onClick={() => setAdd(true)}/>
                    </>}
                {!s_char.value.cc_skills ?
                    <Item>
                        <div>Punkte verteilt:</div>
                        <ul style={{textAlign: 'left'}}>{dist().map(d => <li key={v4()}>{d}</li>)}</ul>
                        {done() ? <Button onClick={cc_done_skills}>abschliessen</Button> :
                            <AddIcon onClick={() => setAdd(true)}/>}
                    </Item>
                    : null
                }
            </h3>
            <Paper>
            </Paper>

            <Paper key={v4()} style={{padding: 4}}>
                <TableContainer style={{maxHeight: s_app_mobile.value ? '50%' : 450}} ref={tableContainerRef}>
                    <Table stickyHeader style={{width: '100%'}} size="small">
                        <TableBody>
                            {s_char_skills.value.map((skill) => skillRow(skill))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

        </Paper>
        <SkillsEdit edit={edit} isOpen={setEdit}/>
        <SkillsAdd add={add} isOpen={setAdd}/>
    </Fragment>
}

export default Skills;
